export default __webpack_public_path__ + "static/media/Belfort_tourisme.79f2f49d.jpg";